import React, { createContext, useContext, useState } from 'react';

type BlogContextType = {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
};

const BlogContext = createContext<BlogContextType | undefined>(undefined);

export const BlogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <BlogContext.Provider value={{ searchTerm, setSearchTerm }}>
      {children}
    </BlogContext.Provider>
  );
};

export const useBlog = () => {
  const context = useContext(BlogContext);
  if (!context) {
    throw new Error('useBlog must be used within a BlogProvider');
  }
  return context;
}; 